import copy from 'copy-to-clipboard'
import { TranslatedText } from 'core'

export const copyToClipboard = (text: TranslatedText) => {
  copy(text)
}
